import { createContext, ReactNode, useContext, useState } from 'react'
import FormW2 from '@assets/form_w2.jpg'
import Form1099 from '@assets/form_1099.png'
import Form1040 from '@assets/form_1040.png'
import SSNImage from '@assets/ssn_iamge.png'
import Disabilitymage from '@assets/disability.png'

export type TaxForms = 'form_1040' | 'form_w2' | 'form_1099'  | "nontaxable"
interface ITaxForms {
  name: string
  code: TaxForms
  description: string
  image: string
}

export const taxforms: ITaxForms[] = [
  {
    name: 'form_w2',
    code: 'form_w2',
    description: 'form_w2_text',
    image: FormW2,
  },
  {
    name: 'form_1099',
    code: 'form_1099',
    description: 'form_1099_text',
    image: Form1099,
  },
  {
    name: 'form_1040',
    code: 'form_1040',
    description: 'form_1040_text',
    image: Form1040,
  },
] as const

export interface NonTaxableIncome {
  name: string
  code: string
  image: string
  done: boolean
}

export const nonTaxableIncomeforms: NonTaxableIncome[] = [
  {
    name: 'social_security',
    code: 'social_security',
    image: SSNImage,
    done: false,
  },
  {
    name: 'disability_benefits',
    code: 'disability_benefits',
    image: Disabilitymage,
    done: false,
  },
  {
    name: 'child_support_payments',
    code: 'child_support_payments',
    image: Disabilitymage,
    done: false,
  },
  {
    name: 'alimony_payments',
    code: 'alimony_payments',
    image: Disabilitymage,
    done: false,
  },
  {
    name: 'other',
    code: 'other',
    image: Disabilitymage,
    done: false,
  },
]

interface FormData {
  DocumentImage?: string
  selectedTaxForm?: ITaxForms
  selectedNonTaxableForm?: NonTaxableIncome[]
  householdSize?: number
  householdIncomeType?: string
  householdFileType?: string
  selectedMember?: string
  memberCompletionStatus?: Record<string, boolean>
  DateOfBirthFile?: File
}

type WizardContext = {
  formData: FormData
  updateFormData: (field: keyof FormData, value: any) => void
}

const Context = createContext<WizardContext | undefined>(undefined)

export const IncomeVerificationWizardProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [formData, setFormData] = useState<FormData>({})

  const updateFormData = (field: keyof FormData, value: any) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }))
  }

  return (
    <Context.Provider
      value={{
        formData,
        updateFormData,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useWizardContext = () => {
  const context = useContext(Context)

  if (context === undefined)
    throw new Error('useWizardContext must be used within the WizardProvider')
  return context
}
